// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"328":"admin","501":"public"}[chunkId] || chunkId) + "." + {"328":"1e1188ed","501":"4f4d55c6","891":"2b04b0d3"}[chunkId] + ".js";
};